import React from 'react';

const FinalResultCardHeader: React.FC = () => {
  return (
    
          <div className="list-header">
            <div className="entry-number">
              <h5 className="performance-list-text">Entry</h5>
            </div>
            <div className="program-or-performer">
              <h5 className="performance-list-text">Program/Performer</h5>
            </div>
            <div className="final-place">
              <h5 className="performance-list-text">FP</h5>
            </div>
            <div className="final-place">
              <h5 className="performance-list-text">PP</h5>
            </div>
            <div className="routine-name">
              <h5 className="performance-list-text">Routine</h5>
            </div>
            <div className="total-score">
              <h5 className="performance-list-text">Total</h5>
            </div>
          </div> 
  );
};

export default FinalResultCardHeader;
